import { BaseEnum } from "./baseEnum";

const listEnum: Array<JustificationOccurrenceDisciplinaryMeasure> = [];

export class JustificationOccurrenceDisciplinaryMeasure extends BaseEnum {
    static ActOfDishonesty = new JustificationOccurrenceDisciplinaryMeasure(
        1,
        "ActOfDishonesty",
        "Ato de improbidade"
    );
    static MisconductOrImproperBehavior =
        new JustificationOccurrenceDisciplinaryMeasure(
            2,
            "MisconductOrImproperBehavior",
            "Incontinência de conduta ou mau procedimento"
        );
    static HabitualNegotiation = new JustificationOccurrenceDisciplinaryMeasure(
        3,
        "HabitualNegotiation",
        "Negociação habitual"
    );
    static CriminalConviction = new JustificationOccurrenceDisciplinaryMeasure(
        4,
        "CriminalConviction",
        "Condenação criminal"
    );
    static NegligenceInPerformingDuties =
        new JustificationOccurrenceDisciplinaryMeasure(
            5,
            "NegligenceInPerformingDuties",
            "Desídia no desempenho das respectivas funções"
        );
    static HabitualOrOnDutyIntoxication =
        new JustificationOccurrenceDisciplinaryMeasure(
            6,
            "HabitualOrOnDutyIntoxication",
            "Embriaguez habitual ou em serviço"
        );
    static ViolationOfCompanySecrets =
        new JustificationOccurrenceDisciplinaryMeasure(
            7,
            "ViolationOfCompanySecrets",
            "Violação de segredo da empresa"
        );
    static ActOfIndisciplineOrInsubordination =
        new JustificationOccurrenceDisciplinaryMeasure(
            8,
            "ActOfIndisciplineOrInsubordination",
            "Ato de indisciplina ou insubordinação"
        );
    static JobAbandonment = new JustificationOccurrenceDisciplinaryMeasure(
        9,
        "JobAbandonment",
        "Abandono de emprego"
    );
    static PhysicalAggressions = new JustificationOccurrenceDisciplinaryMeasure(
        10,
        "PhysicalAggressions",
        "Ofensas físicas"
    );
    static OffensesToHonorAndGoodMorals =
        new JustificationOccurrenceDisciplinaryMeasure(
            11,
            "OffensesToHonorAndGoodMorals",
            "Lesões à honra e à boa forma"
        );
    static ConstantGamblingPractice =
        new JustificationOccurrenceDisciplinaryMeasure(
            12,
            "ConstantGamblingPractice",
            "Prática constante de jogos de azar"
        );

    constructor(public id: number, public value: string, public label: string) {
        super(id, value, label);
        listEnum.push(this);
    }

    public static buildListEnum(): Array<BaseEnum> {
        return listEnum;
    }
}
